import React from "react";

export function NutritionistPayments() {
  return <p>Balance.</p>;
}
